import { Component, computed, EventEmitter, Output, Signal, signal, WritableSignal } from '@angular/core';
import { CLIENT_ID } from '@environments/environment';
import { ItemSizeSelector } from 'src/app/models/enums/ItemSizeSelector.enum';

@Component({
  selector: 'app-item-size-selector',
  standalone: true,
  templateUrl: './item-size-selector.component.html',
  styleUrl: './item-size-selector.component.scss'
})
export class ItemSizeSelectorComponent {

  @Output('onChangeSize') onChangeSize: EventEmitter<ItemSizeSelector> = new EventEmitter();

  static readonly ITEM_SELECTOR_SIZE = `app.item.size.${CLIENT_ID}`;

  private _selectedSize: WritableSignal<ItemSizeSelector> = signal(ItemSizeSelectorComponent.getSizeFromLocalStorage());
  public selectedSize: Signal<ItemSizeSelector> = computed(() => this._selectedSize());

  //Struttra a matrice per renderizzare il corretto numero di quadratini all'interno dei pulsanti
  public squares: any[] = [];


  constructor() {
    this.squares = new Array(3).fill([]).map((square, i) => {
      return new Array(Math.pow(4, i)).fill(null);
    }).reverse();
    //Emitto il valore della size salvato nello storage
    this.handleClick(this.selectedSize());
  }

  handleClick(size: number) {
    this._selectedSize.set(size);
    this.onChangeSize.emit(size);
    this.saveSizeInLocalStorage(size);
  }

  saveSizeInLocalStorage(size: ItemSizeSelector) {
    localStorage.setItem(ItemSizeSelectorComponent.ITEM_SELECTOR_SIZE, size.toString());
  }

  static getSizeFromLocalStorage(): ItemSizeSelector {
    let size: string | null = localStorage.getItem(this.ITEM_SELECTOR_SIZE);
    if (size) {
      return parseInt(size) as ItemSizeSelector;
    }
    return ItemSizeSelector.Medium;
  }

}
